import styled from 'styled-components';

export const InvoiceTableStyled = styled.div`
  display: flex;
  flex-direction: column;

  .notes {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & .notes-data {
      display: flex;
      gap: 5px;
      flex-direction: column;
    }

    & .sub-total {
      display: flex;
      justify-content: space-between;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        justify-content: end;
        gap: 30px;
        min-width: 200px;
        padding-right: 30px;
      }
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      flex-direction: row-reverse;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 40px;
  }
`;
